import {
  Box,
  Button,
  Heading,
  Icon,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
  useColorModeValue,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import React, { useState } from "react";
import { FaChartLine, FaHandshake, FaTools, FaUsers } from "react-icons/fa";
import partnericon from "../../../assets/images/partnericon.png";
import partnerImage from "../../../assets/images/partners.png";
import Header from "../header/Header";
import { useHomeHook } from "../home/useHomeHook";
const MotionBox = motion(Box);

const partners = [
  {
    src: partnericon,
    alt: "Partner 1",
    name: "Tech Solutions Inc.",
    description: "Leading provider of innovative glass solutions",
    specialty: "Commercial Projects",
    location: "Mumbai, India",
  },
  {
    src: partnericon,
    alt: "Partner 2",
    name: "Modern Interiors",
    description: "Experts in residential interior solutions",
    specialty: "Residential Projects",
    location: "Delhi, India",
  },
  {
    src: partnericon,
    alt: "Partner 3",
    name: "Glass Masters",
    description: "Specialized in custom glass installations",
    specialty: "Custom Projects",
    location: "Bangalore, India",
  },
  {
    src: partnericon,
    alt: "Partner 4",
    name: "Design Innovators",
    description: "Creative architectural solutions provider",
    specialty: "Architectural Projects",
    location: "Chennai, India",
  },
  {
    src: partnericon,
    alt: "Partner 5",
    name: "Elite Installations",
    description: "Premium installation services",
    specialty: "Installation Services",
    location: "Hyderabad, India",
  },
];

const benefits = [
  {
    icon: FaHandshake,
    title: "Strategic Partnership",
    description: "Join forces with industry leaders and expand your reach",
  },
  {
    icon: FaChartLine,
    title: "Growth Opportunities",
    description: "Access new markets and increase your revenue potential",
  },
  {
    icon: FaTools,
    title: "Technical Support",
    description: "Get comprehensive training and technical assistance",
  },
  {
    icon: FaUsers,
    title: "Network Access",
    description: "Connect with industry experts and fellow partners",
  },
];

const ChannelPartners = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedPartner, setSelectedPartner] = useState(null);
  const bgGradient = useColorModeValue(
    "linear(to-br, #800080, pink.50)",
    "linear(to-br, #800080, pink.900)"
  );
  const cardBg = useColorModeValue("white", "#000000");
  const [handleMenuEnter, handleMenuLeave, menuVisible, setHoveredItem] =
    useHomeHook(props);
  const handlePartnerClick = (partner) => {
    setSelectedPartner(partner);
    onOpen();
  };
  return (
    <Box bgGradient={bgGradient} borderRadius={{ base: 0, md: "xl" }}>
      <Header
        handleMenuEnter={handleMenuEnter}
        handleMenuLeave={handleMenuLeave}
        menuVisible={menuVisible}
        setHoveredItem={setHoveredItem}
        collections={[
          { name: "Sliding Partitions", path: "/product/1" },
          { name: "Swing Partitions", path: "/product/2" },
          // { name: "Flush Doors", path: "/product/3" },
          { name: "Bathroom & Wardrobes", path: "/product/4" },
          { name: "Shower Enclosures", path: "/product/5" },
          { name: "Led Mirrors", path: "/product/6" },
        ]}
      />
      <Box py={28} px={8}>
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Heading
            as="h1"
            size="2xl"
            mb={8}
            textAlign="center"
            bgGradient="linear(to-r, pink.500, #800080)"
            bgClip="text"
          >
            Our Channel Partners
          </Heading>
          <Text
            fontSize="xl"
            color="#000000"
            textAlign="center"
            maxW="3xl"
            mx="auto"
            mb={12}
          >
            We collaborate with industry leaders to provide the best solutions
            for our clients. Our channel partners are integral to our success,
            helping us deliver innovative and quality products.
          </Text>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8} mb={16}>
            {partners.map((partner, index) => (
              <MotionBox
                key={partner.alt}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                cursor="pointer"
                onClick={() => handlePartnerClick(partner)}
              >
                <VStack
                  align="center"
                  bg={cardBg}
                  p={8}
                  borderRadius="xl"
                  boxShadow="xl"
                  transition="transform 0.3s, box-shadow 0.3s"
                  _hover={{ transform: "translateY(-5px)", boxShadow: "3xl" }} // Enhanced hover effect
                  height="100%"
                >
                  <Image
                    src={partner.src}
                    alt={partner.alt}
                    objectFit="contain"
                    maxW="200px"
                    mb={4}
                  />
                  <Heading size="md" color="#800080" mb={2}>
                    {partner.name}
                  </Heading>
                  <Text color="#000000" textAlign="center">
                    {partner.description}
                  </Text>
                </VStack>
              </MotionBox>
            ))}
          </SimpleGrid>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={8} mb={16}>
            {benefits.map((benefit, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <VStack
                  bg={cardBg}
                  p={6}
                  borderRadius="lg"
                  boxShadow="md"
                  height="100%"
                >
                  <Icon
                    as={benefit.icon}
                    w={10}
                    h={10}
                    color="#000000"
                    mb={4}
                  />
                  <Heading size="md" color="#FFFFFF" mb={2}>
                    {benefit.title}
                  </Heading>
                  <Text color="#000000" textAlign="center">
                    {benefit.description}
                  </Text>
                </VStack>
              </MotionBox>
            ))}
          </SimpleGrid>
          <Box mb={16}>
            <Heading
              as="h2"
              size="xl"
              mb={6}
              textAlign="center"
              color="#800080"
            >
              What Our Partners Say
            </Heading>
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
              <VStack
                bg={cardBg}
                p={6}
                borderRadius="lg"
                boxShadow="md"
                height="100%"
              >
                <Text color="#000000" textAlign="center">
                  "Partnering with this company has been a game-changer for us.
                  Their support and resources are unmatched."
                </Text>
                <Text fontWeight="bold" color="#800080" textAlign="center">
                  - Partner Name
                </Text>
              </VStack>
            </SimpleGrid>
          </Box>
          <MotionBox
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <Box
              p={10}
              textAlign="center"
              borderRadius="xl"
              boxShadow="2xl"
              bgImage={`url(${partnerImage})`}
              bgSize="cover"
              bgPosition="center"
              color="white"
              position="relative"
              overflow="hidden"
              _before={{
                content: '""',
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                bg: "rgba(0,0,0,0.7)",
                zIndex: 0,
              }}
            >
              <Box position="relative" zIndex={1}>
                <Heading as="h2" size="xl" mb={6}>
                  Become a Partner with Us
                </Heading>
                <Text fontSize="lg" mb={8} maxW="2xl" mx="auto">
                  Are you ready to elevate your business and explore exciting
                  partnership opportunities? Join our network of industry
                  leaders and together, let's innovate and inspire.
                </Text>
                <Button
                  colorScheme="purple"
                  size="lg"
                  px={8}
                  py={6}
                  onClick={onOpen}
                  _hover={{
                    transform: "translateY(-2px)",
                    boxShadow: "xl",
                  }}
                >
                  Get in Touch
                </Button>
              </Box>
            </Box>
          </MotionBox>
        </MotionBox>
        <Modal isOpen={isOpen} onClose={onClose} size="xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader color="#800080">
              {selectedPartner ? selectedPartner.name : "Partner With Us"}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              {selectedPartner ? (
                <VStack align="start" spacing={4}>
                  <Image
                    src={selectedPartner.src}
                    alt={selectedPartner.alt}
                    maxW="200px"
                    mx="auto"
                    mb={4}
                  />
                  <Text>
                    <strong>Specialty:</strong> {selectedPartner.specialty}
                  </Text>
                  <Text>
                    <strong>Location:</strong> {selectedPartner.location}
                  </Text>
                  <Text>{selectedPartner.description}</Text>
                </VStack>
              ) : (
                <VStack align="start" spacing={4}>
                  <Text>
                    Please fill out the form below to become a partner.
                  </Text>
                </VStack>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box>
    </Box>
  );
};

export default ChannelPartners;
